var map = {
	"./1.jpeg": "2c81",
	"./10.jpeg": "7cb7",
	"./2.jpeg": "ddaf",
	"./3.jpeg": "c8a5",
	"./4.jpeg": "6a7d",
	"./5.jpeg": "2559",
	"./6.jpeg": "37ce",
	"./7.jpeg": "cf21",
	"./8.jpeg": "3fb9",
	"./9.jpeg": "067e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f9b";